var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172.005,
    height: 172.012,
    viewBox: "0 0 172.005 172.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_49",
    "data-name": "Rect\\xE1ngulo 49",
    width: 172.005,
    height: 172.012,
    fill: "#faab12",
    stroke: "#f9ac15",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(-0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    "data-name": "Trazado 68",
    d: "M79.093,158.2A79.09,79.09,0,0,1,31.647,15.806a79.108,79.108,0,0,1,102.245,6.25,3.7,3.7,0,1,1-5.122,5.331A71.683,71.683,0,0,0,7.39,79.1,72.576,72.576,0,0,0,8.126,89.41,71.709,71.709,0,0,0,150.8,79.1a3.695,3.695,0,1,1,7.39,0,79.036,79.036,0,0,1-79.1,79.1",
    transform: "translate(6.908 6.909)",
    fill: "#faab12",
    stroke: "#f9ac15",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M64.655,123.61a58.821,58.821,0,0,1-30.5-8.516,3.567,3.567,0,1,1,3.7-6.1,52.332,52.332,0,0,0,40.486,5.649A51.532,51.532,0,0,0,90.945,109.3a52.221,52.221,0,0,0,21.116-23.7,51.837,51.837,0,0,0,2.651-34.416,51.828,51.828,0,0,0-58.5-37.676c-.552.088-1.094.189-1.636.3A51.846,51.846,0,0,0,14.254,76.75a3.565,3.565,0,1,1-6.932,1.667A58.994,58.994,0,0,1,53.2,6.812c.619-.122,1.231-.235,1.856-.338a59.544,59.544,0,0,1,23.45.862A58.96,58.96,0,0,1,64.655,123.61",
    transform: "translate(21.346 21.355)",
    fill: "#faab12",
    stroke: "#f9ac15",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M49.927,88.465a38.536,38.536,0,0,1,0-77.072,38.294,38.294,0,0,1,14,2.633,3.3,3.3,0,1,1-2.4,6.153A31.923,31.923,0,0,0,31.934,76.292,31.929,31.929,0,0,0,81.86,49.931,31.706,31.706,0,0,0,79.7,38.384a3.3,3.3,0,1,1,6.156-2.393A38.518,38.518,0,0,1,83.906,68.1,38.494,38.494,0,0,1,49.927,88.465",
    transform: "translate(36.074 36.077)",
    fill: "#faab12",
    stroke: "#f9ac15",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoYellow);
export default __webpack_public_path__ + "static/media/Iso-yellow.14cf23e7217fcb048009e7882993df8f.svg";
export { ForwardRef as ReactComponent };